import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { motion } from "framer-motion";
import Typed from "react-typed";
import PortableText from "react-portable-text";

import "./Home.css";

import TopBar from "../../components/TopBar/TopBar";
import Button from "../../components/Button/Button";

import { client } from "../../client";
import { Link } from "react-router-dom";

const Home = () => {
  
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Shreeyash Parsawar - Portfolio";
  }, []);

  // api section

  const [landingsection, setLandingsection] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "landingsection"]{
          name,
          shortdesc,
          profileimg{
            asset->{
                _id,
                url
            }
        },
          "downloadcv": downloadcv.asset->url
            
        } `;

    setLoading(true);

    client.fetch(query).then((data) => {
      setLandingsection(data);
      setLoading(false);
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionHome">
          <TopBar />

          <section className="main ">
            {landingsection.length > 0 && (
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-1"></div>

                  <div className="col-md-12 mProfile text-center">
                    <img
                      src={landingsection[0].profileimg.asset.url}
                      className="img-fluid "
                      alt=""
                      style={{ width: "250px", height: "250px" }}
                    />
                  </div>

                  <div className="col-lg-6 col-md-8">
                    <h2 className="subHeading">
                      <span className="shaking-text">👋 </span>
                      Hello, I am
                    </h2>

                    <h1 className="headingText">{landingsection[0].name}</h1>

                    <Typed
                      strings={[
                        "Frontend Web Developer!",
                        "MERN Stack Developer!",
                        "Ui/ux Designer!",
                        "Graphics Designer!",
                        "Wordpress Developer!",
                      ]}
                      typeSpeed={40}
                      backSpeed={50}
                      loop
                      className="animatedText"
                    />

                    <PortableText
                      content={landingsection[0].shortdesc}
                      className="paraText"
                    />

                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-6 mt-3 text-center ">
                          <a
                            href={`${landingsection[0].downloadcv}?dl=Shreeyash_Parsawar_Resume.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button title="Download Resume" />
                          </a>
                        </div>

                        <div className="col-lg-6 col-md-6 col-6 mt-3 text-center">
                          <Link to="/contact">
                            <Button title="As a Freelancer" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </section>



          {/* <Navbar /> */}
        </section>
        
      )}
    </motion.div>
  );
};

export default Home;
